export default {
    container: {
        height: "calc(100% - 48px - 1px)",
        "& .MuiDataGrid-root": {
            border: "none"
        }
    },
    marginLeft: {
        marginLeft: 2
    },
    textWrapContainer: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "10em"
    }
};
